import { render, staticRenderFns } from "./Sources.vue?vue&type=template&id=1b8c961e&scoped=true&"
import script from "./Sources.vue?vue&type=script&lang=js&"
export * from "./Sources.vue?vue&type=script&lang=js&"
import style0 from "./Sources.vue?vue&type=style&index=0&id=1b8c961e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8c961e",
  null
  
)

export default component.exports